module.exports = __webpack_public_path__ + "img/vertical_6_6_8004.c7d3563a.png";